function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "bicycle");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "bicycle"
}, /*#__PURE__*/React.createElement("polygon", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  points: "17.99 21.27 39.69 26.04 50.71 41.63 33.46 41.63 17.99 21.27"
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  points: "28.31 11.26 20.77 11.26 12.51 40.98"
}), /*#__PURE__*/React.createElement("line", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  x1: 33.46,
  y1: 41.63,
  x2: 43.4,
  y2: 16.55
}), /*#__PURE__*/React.createElement("line", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  x1: 47.34,
  y1: 16.55,
  x2: 39.46,
  y2: 16.55
}), /*#__PURE__*/React.createElement("circle", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  cx: 50.71,
  cy: 41.63,
  r: 10.57
}), /*#__PURE__*/React.createElement("circle", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  cx: 12.51,
  cy: 40.98,
  r: 10.57
}));

var SvgBicycle = function SvgBicycle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icons",
    viewBox: "0 0 64 64",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBicycle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bicycle.feab0856.svg";
export { ForwardRef as ReactComponent };